import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { Route } from '../envs/types';
import getCurrentRoute from '../utils/getCurrentRoute';

export const useCurrentRoute = (): Route | undefined => {
  const location = useLocation();
  const currentRoute = useMemo(() => getCurrentRoute(location), [location]);

  return currentRoute;
};
